export default __webpack_public_path__ + "b7fe89afec80c48afb771edc7f5276a2.png";